<template>
  <div class="pdl-tabs__active-bar" :key="activeTabName" :class="`is-${tabPosition}`" :style="barStyle"></div>
</template>

<script>
const TAB_ANIMATION_DURATION = 300; // ms
export default {
  name: 'TabBar',

  inject: ['navWidth', 'activeTabName'],

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    padding: {
      type: Number,
      default: 16,
    },
    tabPosition: {
      type: String,
      default: 'top',
    },
  },
  watch:{
    navWidth:{
      handler(){
        window.setTimeout(() => {
          this.updateBarStyle();
        }, TAB_ANIMATION_DURATION);
      },
      deep:true
    },
    activeTabName:{
      handler(){
        window.setTimeout(() => {
          this.updateBarStyle();
        }, TAB_ANIMATION_DURATION);
      },
      deep:true
    },
    tabs:{
      handler(){
        window.setTimeout(() => {
          this.updateBarStyle();
        }, TAB_ANIMATION_DURATION);
      },
      deep:true
    }
  },
  data(){
    return {
      barStyle: {}
    }
  },
  computed: {
    innerTabPadding() {
      //Inner tabs have padding on left and right sides
      return this.padding * 2;
    },
  },
   methods:{
    updateBarStyle(){
      //Mentioning variables here so this is reactive to those properties changing
      let tabs = this.tabs;
      let tabsContainer = this.$parent.$refs.tabs;
      let navContainer = this.$parent.$refs.nav;

      if (!tabsContainer || !navContainer) return {};

      let style = {};
      let offset = 0;
      let tabSize = 0;

      const sizeName = ['top', 'bottom'].indexOf(this.tabPosition) !== -1 ? 'width' : 'height';
      const sizeDir = sizeName === 'width' ? 'x' : 'y';

      const firstUpperCase = (str) => {
        return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
      };

      tabs.every((tab, index) => {
        let tabElement = tabsContainer.find((t) => t.id === `tab-${tab.tabName}`);

        if (!tabElement) {
          return false;
        }
        if (tab.tabName === this.activeTabName) {
          let parentOffset = navContainer.getBoundingClientRect()?.[sizeDir] || 0;
          let tabOffset = tabElement.getBoundingClientRect()?.[sizeDir] || 0;

          offset = tabOffset - parentOffset;
          if (sizeName === 'width' && index !== 0) {
            offset += this.padding;
          }
          tabSize = tabElement[`client${firstUpperCase(sizeName)}`];

          if (sizeName === 'width' && tabs.length > 1) {
            tabSize -= index === 0 || index === tabs.length - 1 ? this.padding : this.innerTabPadding;
          }

          return false;
        } else {
          return true;
        }
      });

      const transform = `translate${firstUpperCase(sizeDir)}(${offset}px)`;
      style[sizeName] = tabSize + 'px';
      style.transform = transform;
      style.msTransform = transform;
      style.webkitTransform = transform;
      this.barStyle = style;
    },
  },
  mounted(){
    this.updateBarStyle();
  }
};
</script>
<style lang="scss">
@import 'Tabs.scss';
</style>
